// extracted by mini-css-extract-plugin
export default {"root":"PhotoModal_root__RjEKK","on":"PhotoModal_on__2J2po","button":"PhotoModal_button__38h2y"};